export const LinesIcon = () => {
 return (
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
    <path d="M18.2438 32.75H25.4105V29.1667H18.2438V32.75ZM5.70215 11.25V14.8333H37.9521V11.25H5.70215ZM11.0771 23.7917H32.5771V20.2083H11.0771V23.7917Z" fill="url(#paint0_linear_1210_4467)"/>
    <defs>
      <linearGradient id="paint0_linear_1210_4467" x1="13.16" y1="14.475" x2="21.2029" y2="34.0002" gradientUnits="userSpaceOnUse">
        <stop stopColor="#004A80"/>
        <stop offset="1" stopColor="#00C0F3"/>
      </linearGradient>
    </defs>
  </svg>
 );
};